<template>
  <AdminModal
    :is-open="isOpen"
    modalSize="lg"
    modal-title="강의 접속 코드 생성"
    :confirm="save"
    :close="close"
    :loading="isLoading"
    confirmButtonTitle="저장"
    name="lessonContentUnlockCodeModal"
  >
    <b-container>
      <b-row>
        <b-col cols="12">접속 코드 유효 기간</b-col>
        <b-col cols="4">
          <label for="start_date">시작 일자</label>
          <b-form-input
            id="startDt"
            type="date"
            v-model="startDate"
          ></b-form-input>
        </b-col>
        <b-col cols="4">
          <label for="end_date">종료 일자</label>
          <b-form-input
            id="startDt"
            type="date"
            v-model="endDate"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col>
          <label for="start_date">수업 선택</label>
          <Multiselect
            v-model="selectedLessonContents"
            v-bind="setting"
          ></Multiselect>
        </b-col>
      </b-row>
    </b-container>
  </AdminModal>
</template>

<script>
import api from "@/api/api"
import AdminModal from "@/components/modals/AdminModal.vue";
import Excel from "@/util/excel";

export default {
  name: "BulkCreateLessonContentUnlockCodeModal",
  components: {AdminModal},
  props: ['isOpen', 'reload', 'close', 'lessonContentUnlockCode', 'lessonContents'],
  data() {
    return {
      startDate: '',
      endDate: '',
      isLoading: false,
      selectedLessonContents: [],
      setting: {
        mode: 'tags',
        value: [],
        closeOnSelect: false,
        placeholder: "강의 선택",
        options: [],
        searchable: true,
        createOption: false
      },
    }
  },
  mounted() {
    const today = new Date()
    const year = today.getFullYear()
    const month = today.getMonth() // 0-based (0 = January)
    
    this.startDate = `${year}-${(month + 1).toString().padStart(2, '0')}-01`
    const lastDay = new Date(year, month + 1, 0).getDate()
    this.endDate = `${year}-${(month + 1).toString().padStart(2, '0')}-${lastDay.toString().padStart(2, '0')}`

    
    this.setting.options = this.lessonContents.map((lessonContent) => ({
      value: lessonContent.id,
      label: `${lessonContent.lessonTitle} (${lessonContent.title})`
    }))
   this.selectedLessonContents= this.lessonContents.map((lessonContent) => lessonContent.id)
  },
  methods: {
    formatDate(datetimeString) {
      // Create a new Date object from the datetime string
      const date = new Date(datetimeString);

      // Extract year, month, and day with leading zero for month and day
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');

      // Return formatted date in YYYY-MM-DD format
      return `${year}-${month}-${day}`;
    },
    validate() {
      if (this.selectedLessonContents.length === 0) {
        this.$toast.show('강의를 선택하세요.', { position: 'top-right', duration: 2000 })
        return false
      }

      if (!(this.startDate && this.endDate)) {
        this.$toast.show('시작 일자, 종료 일자를 선택하세요',
          {
            position: "top-right",
            duration: 2000
          });
        return false
      }
      
      return true
    },
    save() {
      if (!this.validate()) return

      const payload =  {
        startedAt: `${this.startDate}`,
        endedAt : `${this.endDate}`,
        lessonContentIds: this.selectedLessonContents
      }
      this.loading = true
      api.lessonContentUnlockCode.bulkCreate(
        payload,
        (response) => {
          Excel.download(response.data, '접속 코드_생성')
          this.reload()
          this.loading = false
          this.$toast.success('업로드 및 엑셀 다운로드 완료',
            {
              position: "top-right",
              duration: 2000
            })
          this.close()
        }, (e) => {
          console.error(e)
          this.loading = false
          this.$toast.error('생성 실패',
            {
              position: "top-right",
              duration: 2000,
            });
        })
     
    },
  }
}
</script>

<style scoped>

</style>